import { ApiType } from 'services/typings'
import { AccountInfoProps } from 'typings/userInfo'
import config from 'const/config'
import responseCodes from 'const/responseCodes'
import { redirectTo } from 'ui/customHooks/useHistory'
import { ServerError } from 'typings/serverError'
import routePaths from 'const/routePaths'

export const getAPIHost = (type: ApiType): string => {
  const { DESIGN_API_HOST, API_HOST, ASSET_HOST, SANDBOX_HOST } = config
  switch (type) {
    case 'DESIGN_API':
      return DESIGN_API_HOST
    case 'ASSETS':
      return ASSET_HOST
    case 'SANDBOX':
      return SANDBOX_HOST
    default:
      // need to protect from overriding when it should be prevented
      return config.ALLOW_OVERRIDES === 'yes'
        ? window.appConfigOverrides?.apiHost
        : API_HOST
  }
}

export const getAccountDetailQuery = (
  accountDetail: AccountInfoProps
): AccountInfoProps => {
  const encodedParams: Record<string, string> = {}
  Object.entries(accountDetail).forEach(([key, value]) => {
    encodedParams[key] = encodeURIComponent(value)
  })
  return encodedParams
}

export const handleError = (
  errorResponse: ServerError,
  isBadRequestAllowed: boolean,
  permittedErrorCodes = [400, 422],
  noRedirect = false
): void => {
  const sessionExpired = [401, 403]
  const { statusCode, description, businessErrorCode } = errorResponse
  if (
    sessionExpired.includes(statusCode) &&
    description.replace(/\s/g, '') === responseCodes.sessionExpired
  ) {
    setTimeout(() => {
      redirectTo(routePaths.sessionExpired)
    }, 100)
    return
  }

  const allowError =
    permittedErrorCodes.includes(statusCode) &&
    (isBadRequestAllowed || businessErrorCode)

  if (noRedirect || allowError) {
    return
  }

  setTimeout(() => {
    redirectTo(routePaths.error)
  }, 100)
}
